import { personsAndTeamsOf } from '../values.js';
export async function resolveReceiver(context, receiver) {
    const value = receiver.value;
    switch (receiver.type) {
        case 'me':
            // "Me" is the automation's owner: it is their automation, and a run acts as them (§5.4).
            return [context.ownerId];
        case 'user':
            return value === null ? [] : [String(typeof value === 'object' ? '' : value)].filter((id) => id.length > 0);
        case 'team':
            return value === null ? [] : context.services.teamMembers(String(value));
        case 'board':
            return context.services.boardSubscribers(context.boardId);
        case 'subscriber':
            if (value === 'board')
                return context.services.boardSubscribers(context.boardId);
            return context.itemId === null ? [] : context.services.itemSubscribers(context.itemId);
        case 'column': {
            if (context.itemId === null || value === null)
                return [];
            // `value` is a bare column id or a full column reference; both forms occur.
            const columnId = typeof value === 'object' ? value.columnId : String(value);
            const cell = await context.services.getCellValue(context.itemId, columnId);
            const people = personsAndTeamsOf(cell).filter((entry) => entry.kind === 'person').map((entry) => String(entry.id));
            if (people.length > 0)
                return people;
            // A `creation_log` column resolves to the item's creator (`specs/M6-A3` §12 AC 3).
            const item = await context.services.getItem(context.itemId);
            return item?.createdBy === null || item === null ? [] : [item.createdBy];
        }
        default:
            return [];
    }
}
/** De-duplicates and drops empties, so "notify the same person twice" cannot happen. */
export const uniqueRecipients = (ids) => [...new Set(ids.filter((id) => id.length > 0))];
//# sourceMappingURL=receiver.js.map